// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Gw6Jm","review":"styles_review__m5sCJ system_textBodyL__xkApD","reviewText":"styles_reviewText__beN_B","reviewLink":"styles_reviewLink__T84AF"};